import type {MapaStageDto} from '@devmil/contracts';

import {MAPA_STAGE_LABEL} from '../../lib/format.js';

/** As quatro etapas do funil, na ordem aprovada, com a seta entre elas. */
export const FunnelSummary = ({stages}: {stages: readonly MapaStageDto[]}) => (
  <div className="dm-funnel" role="group" aria-label="Etapas do funil MAPA">
    {stages.map((stage) => (
      <div className="dm-funnel-step" key={stage.id} data-testid="mapa-stage">
        <span>{MAPA_STAGE_LABEL[stage.id]}</span>
        <strong>{stage.count}</strong>
      </div>
    ))}
  </div>
);
